import { EntityRepository, Repository } from "typeorm";
import { DocumentsApproval } from "../entities/documents-approval.entity";

@EntityRepository(DocumentsApproval)
export class DocumentsApprovalRepository extends Repository<DocumentsApproval>{

}